import styled from '@emotion/styled';

export const Content = styled.div`
    @media screen {
        margin: 40px;
        .mb-4 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 32px;
            line-height: 37px;
            text-align: center;
            padding-bottom : 32px;
        }
        .mb-5 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 28px;
            line-height: 37px;
            text-align: left;
        }
        p {
            font-family: Source Sans Pro;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 24px;
        }

        .btn-primary {
            margin-top : 20px;
        }

        .container-dropzone {

        }
       

        .dropzone {
            border: 1px dashed black;
            background-color : white;
            height : 150px;
            margin-bottom : 50px;
        }

        .text-center{
            text-align: center;
        }

        .previewObject{
            height : 200px;
        }

        // .poster {
        //     margin-top: 100px;
        // }

        .card-body {
            margin: 0 8px;
        }
            
        `;

export const PosterImg = styled.img`
  width: 100%;
`;

export const ButtonsContainer = styled.div`
  margin: 24px;
`;
